import { ItemPedido } from "./pedido";

export class IndicadorAnaliseDesconto {
  id: number;
  descricao: string;
  de: number;
  ate: number;
  cor: string;
  idProduto?: number;

  // mutáveis
  editando: boolean;
  deAnterior?: number;
  ateAnterior?: number;
}

export class CalculoIndicador {
  itens: ItemPedido[];
  subTotal: number;
  valorTotal: number;
  valorFinal: number;
  valorRepasse: number;
  valorFrete: number;
  da: number;
  valorDa: number;
  taxaDa: number;
  aliqImpRef: number;
}

export class ExcecaoIndicadorAnaliseDesconto {
  idProduto: number;
  descricao: string;
  indicadores: IndicadorAnaliseDesconto[];
}
